import React, { useState,useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import Documents from "../Documents";
import axios from "axios";
import LomnsAndQuestionares from "./LomnsAndQuestionares";

const PatientDocumentsAndLOMNs = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const patientid = props.patientid
  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.5,
          background: "linear-gradient(70deg, #4facfe, #00f2fe)",
          color: "#fff",
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Patient Documents Management
        </Typography>
      </Box>

      {/* Tabs */}
      <Tabs
        value={tabIndex}
        onChange={handleChange}
        variant="fullWidth"
        sx={{
          backgroundColor: "#f9fafb",
        }}
      >
        <Tab label="Documents/Images" />
        <Tab label="LOMNs/Questionnaires" />
      </Tabs>

      {/* Tab Panels */}
      <Box sx={{ p: 2 }}>
        {tabIndex === 0 && (
          <Box>
             <Documents callingFrom={"test"} patientid={patientid}/>
          </Box>
        )}
        {tabIndex === 1 && (
          <Box>
            <LomnsAndQuestionares 
            
            patientId={props.patientId}
             Patientinfo={props.Patientinfo}
             OtherPatientInfo={props.OtherPatientInfo} 
             PatientName={props.PatientName}
             patientid={props.patientId}
              callingFrom={"test"}
            ></LomnsAndQuestionares>
          </Box>
        )}
        
     
      </Box>
    </Paper>
  );
};

export default PatientDocumentsAndLOMNs;